export const jurosCorrecaoSectionKeys = [
    "indexadorCorrecaoPercentual",
    "defasagem",
    "calculoDiasIndexador",
    "formulaIndexador",
    "calculoDias",
    "jurosCapitalizacao",
    "periodicidadeAtualizacaoMonetaria",
    "mesAniversarioAnualSemestral",
    "projecaoInflacao",
    "inflacaoNegativa",
    "recalculoProjecao",
    "aplicacaoAmortizacao",
    "corrigeDataEvento",
]